import React from 'react'
import LogIn from '../components/LogIn'

const LoginPage = () => {
  return (
   <LogIn />
  )
}

export default LoginPage